import React, { useState } from 'react';
import { Row, Col, Modal, Button } from 'antd';
import { LeftOutlined, RightOutlined, CloseOutlined } from '@ant-design/icons';
import one from "../assets/gallary/1.jpg";
import two from "../assets/gallary/2.jpg";
import three from "../assets/gallary/3.jpg";
import four from "../assets/gallary/4.jpg";
import five from "../assets/gallary/5.jpg";
import six from "../assets/gallary/6.jpg";
import seven from "../assets/gallary/7.jpg";
import eight from "../assets/gallary/8.jpg";
import nine from "../assets/gallary/9.jpg";
import ten from "../assets/gallary/10.jpg";
import eleven from "../assets/gallary/11.jpg";
import twelve from "../assets/gallary/12.jpg";
import thirteen from "../assets/gallary/13.jpg";
import fourteen from "../assets/gallary/14.jpg";
import sixteen from "../assets/gallary/16.jpg";
import seventeen from "../assets/gallary/17.jpg";
import eighteen from "../assets/gallary/18.jpg";
import nineteen from "../assets/gallary/19.jpg";
import twenty from "../assets/gallary/20.jpg";
import twentyOne from "../assets/gallary/21.jpg";
import twentyTwo from "../assets/gallary/22.jpg";
import twentyThree from "../assets/gallary/23.jpg";
import twentyFour from "../assets/gallary/24.jpg";
import twentyFive from "../assets/gallary/25.jpg";
import twentySix from "../assets/gallary/26.jpg";
import twentySeven from "../assets/gallary/27.jpg";
import twentyEight from "../assets/gallary/28.jpg";
import twentyNine from "../assets/gallary/29.jpg";
import thirty from "../assets/gallary/30.jpg";
import thirtyOne from "../assets/gallary/31.jpg";
import thirtyTwo from "../assets/gallary/32.jpg";
import thirtyThree from "../assets/gallary/33.jpg";
import thirtyFour from "../assets/gallary/34.jpg";
import thirtyFive from "../assets/gallary/35.jpg";
import thirtySix from "../assets/gallary/36.jpg";
import thirtySeven from "../assets/gallary/37.jpg";
import thirtyEight from "../assets/gallary/38.jpg";
import thirtyNine from "../assets/gallary/39.jpg";
import forty from "../assets/gallary/40.jpg";
import fortyOne from "../assets/gallary/41.jpg";

function GallerySection() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const images = [
        one, two, three, four, five, six, seven, eight, nine, ten,
        eleven, twelve, thirteen, fourteen,  sixteen, seventeen, eighteen, nineteen, twenty,
        twentyOne, twentyTwo, twentyThree, twentyFour, twentyFive, twentySix, twentySeven, twentyEight, twentyNine, thirty,
        thirtyOne, thirtyTwo, thirtyThree, thirtyFour, thirtyFive, thirtySix, thirtySeven, thirtyEight, thirtyNine, forty,
        fortyOne
    ];

    const openModal = (index) => {
        setCurrentIndex(index);
        setIsModalOpen(true);
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    return (
        <div style={{
            padding: '40px 24px',
            background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
            minHeight: '100vh'
        }}>
            <div style={{ maxWidth: 1400, margin: '0 auto' }}>
                <Row gutter={[16, 16]}>
                    {images.map((image, index) => (
                        <Col xs={12} sm={8} md={6} lg={6} key={index}>
                            <div
                                onClick={() => openModal(index)}
                                style={{
                                    background: 'white',
                                    borderRadius: 12,
                                    padding: 20,
                                    height: 180,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    border: '2px solid transparent',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                    e.currentTarget.style.borderColor = '#4caf50';
                                    e.currentTarget.style.boxShadow = '0 12px 24px rgba(76, 175, 80, 0.3)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.borderColor = 'transparent';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                }}
                            >
                                <img
                                    src={image}
                                    alt={`Gallery ${index + 1}`}
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '120px',
                                        width: 'auto',
                                        height: 'auto',
                                        objectFit: 'contain',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'scale(1.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'scale(1)';
                                    }}
                                />
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>

            {/* Lightbox Modal */}
            <Modal
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                width="90vw"
                centered
                closeIcon={<CloseOutlined style={{ color: 'white', fontSize: 24 }} />}
                styles={{
                    mask: {
                        backgroundColor: 'rgba(0, 0, 0, 0.85)'
                    },
                    content: {
                        background: 'transparent',
                        boxShadow: 'none',
                        padding: 0
                    },
                    body: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '80vh'
                    }
                }}
            >
                <div style={{ position: 'relative', width: '100%', textAlign: 'center' }}>
                    {/* Main Image */}
                    <img
                        src={images[currentIndex]}
                        alt={`Gallery ${currentIndex + 1}`}
                        style={{
                            maxWidth: '100%',
                            maxHeight: '80vh',
                            objectFit: 'contain',
                            borderRadius: 8,
                            boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
                        }}
                    />

                    {/* Navigation Buttons */}
                    <Button
                        shape="circle"
                        icon={<LeftOutlined />}
                        onClick={handlePrev}
                        style={{
                            position: 'absolute',
                            left: 20,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: 48,
                            height: 48,
                            background: 'rgba(255,255,255,0.2)',
                            border: '2px solid white',
                            color: 'white',
                            fontSize: 20,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backdropFilter: 'blur(5px)',
                            transition: 'all 0.3s'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#4caf50';
                            e.currentTarget.style.borderColor = '#4caf50';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                            e.currentTarget.style.borderColor = 'white';
                        }}
                    />

                    <Button
                        shape="circle"
                        icon={<RightOutlined />}
                        onClick={handleNext}
                        style={{
                            position: 'absolute',
                            right: 20,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: 48,
                            height: 48,
                            background: 'rgba(255,255,255,0.2)',
                            border: '2px solid white',
                            color: 'white',
                            fontSize: 20,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backdropFilter: 'blur(5px)',
                            transition: 'all 0.3s'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#4caf50';
                            e.currentTarget.style.borderColor = '#4caf50';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                            e.currentTarget.style.borderColor = 'white';
                        }}
                    />

                    {/* Image Counter */}
                    <div style={{
                        position: 'absolute',
                        bottom: -40,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: 'rgba(0,0,0,0.6)',
                        color: 'white',
                        padding: '8px 16px',
                        borderRadius: 30,
                        fontSize: 14,
                        backdropFilter: 'blur(5px)',
                        border: '1px solid rgba(255,255,255,0.2)'
                    }}>
                        {currentIndex + 1} / {images.length}
                    </div>
                </div>
            </Modal>

            <style>{`
                /* Custom scrollbar */
                ::-webkit-scrollbar {
                    width: 8px;
                    height: 8px;
                }
                
                ::-webkit-scrollbar-track {
                    background: #e8f5e9;
                }
                
                ::-webkit-scrollbar-thumb {
                    background: #4caf50;
                    border-radius: 4px;
                }
                
                ::-webkit-scrollbar-thumb:hover {
                    background: #2e7d32;
                }
                
                /* Ant Modal customization */
                .ant-modal {
                    max-width: 100%;
                    padding: 0;
                }
                
                .ant-modal-content {
                    background: transparent !important;
                }
                
                .ant-modal-close {
                    top: 20px;
                    right: 20px;
                }
                
                .ant-modal-close:hover {
                    background: transparent !important;
                }
            `}</style>
        </div>
    );
}

export default GallerySection;